import { render, staticRenderFns } from "./MappingContext.vue?vue&type=template&id=3572c10c"
import script from "./MappingContext.vue?vue&type=script&lang=js"
export * from "./MappingContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports